// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Возможно, у вас здесь другие импорты стилей
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* Здесь НЕ должно быть <BrowserRouter> или <Router> */}
    <App />
  </React.StrictMode>
);